// extracted by mini-css-extract-plugin
module.exports = {"header":"dlOJN","headerLeftSide":"Jjxs5","headerRightSide":"_2pMO2","avatar":"_1JMCe"};